// extracted by mini-css-extract-plugin
export default {"backButton":"kfyLWb","title":"zRSVzH","list":"BPa4DE","optionButton":"d0faKo","optionTitle":"YwwvV5"};